module.exports = __webpack_public_path__ + "static/media/four.833b05d8.jpg";